import { IonContent } from '@ionic/react';
import React from 'react';
import { useFormContext } from 'react-hook-form';

import { amplitudeModule } from '@/modules/amplitude';
import {
  OnboardingOptionItem,
  OnboardingOptionsList,
} from '@/pages/Onboarding/components/List';
import { OnboardingNavigation } from '@/pages/Onboarding/components/Navigation';
import { OnboardingPage } from '@/pages/Onboarding/components/Page';
import { useOnboarding } from '@/pages/Onboarding/context';
import { OwnAiTitle } from '@/pages/Onboarding/Layouts/OwnAI/components/Title';
import { HER_PART_DRIVES_CRAZY_COMPATIBILITY_OPTIONS } from '@/pages/Onboarding/options/HerPartDrivesCrazyCompatibility/HER_PART_DRIVES_CRAZY_COMPATIBILITY_OPTIONS';
import { OnbOptionType } from '@/pages/Onboarding/types';
import { nextStepTimeout } from '@/pages/Onboarding/utils/nextStepTimeout';
import { userService } from '@/services/user';
import { canLogEvents } from '@/utils/canLogEvents';

import { LayoutDataType } from '../../types';

export const ScreenHerPartDrivesCrazy: React.FC = () => {
  React.useEffect(() => {
    if (canLogEvents()) {
      amplitudeModule.logEvent('onboarding_screen', {
        seen: 'HerPartDrivesCrazy',
      });
    }
  }, []);

  const { wizard } = useOnboarding();

  const form = useFormContext<LayoutDataType>();

  const herPartDrivesCrazy = form.watch('her_part_drives_crazy');

  const handleChange = (
    option: OnbOptionType<LayoutDataType['her_part_drives_crazy']>,
  ) => {
    userService.createOrUpdate({
      onboarding_data: {
        herPartDrivesCrazy: option.title,
      },
    });
    nextStepTimeout(wizard.nextStep);
  };

  const handleBack = () => {
    wizard.goToStep('relationship_role');
  };

  return (
    <OnboardingPage background={'dark-solid'}>
      <OnboardingNavigation onBack={handleBack} />

      <IonContent>
        <OwnAiTitle>What part of her drives you crazy?</OwnAiTitle>
        <OnboardingOptionsList>
          {HER_PART_DRIVES_CRAZY_COMPATIBILITY_OPTIONS.map((option) => (
            <OnboardingOptionItem
              checked={herPartDrivesCrazy === option.id}
              control={form.control}
              option={option}
              name="her_part_drives_crazy"
              key={option.id}
              onChange={() => handleChange(option)}
              TEST_ID={`her-part-drives-crazy-${option.id}`}
            />
          ))}
        </OnboardingOptionsList>
      </IonContent>
    </OnboardingPage>
  );
};
